import React, { useState } from 'react'
import EDSComponent from '../Components/EDSComponent/EDSComponent'
import EdsService from "../Service/EdsService";

const EDSContainer = () => {
	const [eds, setEds] = React.useState([])
	const [reference, setReference] = React.useState([])
	const [selfHead, setSelfHead] = useState('left')

	const getEds = async () => {
		const data = await EdsService.getEds()
		setEds(eds)
	}

	const change = head => setSelfHead(head)

	React.useEffect(() => {
		getEds()
	}, [])

	return <EDSComponent selfHead={selfHead} change={change} />
}

export default EDSContainer
